import React from "react";
import { mainTable } from "../css/Common";

const Buttons = ({ addScreenTitle, updateScreenTitle, handleSubmit, cancel, disabledBtn, viewSaveButton, onSave,
  onSaveAndProceed, onCheckAvailability, onLost, onHold, onBooking,viewpayroll }) => {
  return (
    <div className={mainTable.submitCancelMainDiv}>
      {addScreenTitle && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={disabledBtn ? mainTable.disabledSubmitButton : mainTable.submitButton}
          onClick={() => handleSubmit(0, 1)}
          disabled={disabledBtn}
        >
          {viewSaveButton ? "Send" : viewpayroll ? "Process Pay": "Submit" }
          
        </button>
      )}
      {updateScreenTitle && (
        <button
          data-modal-hide="bottom-right-modal"
          type="button"
          className={disabledBtn ? mainTable.disabledSubmitButton : mainTable.submitButton}
          onClick={() => handleSubmit(0, 2)}
          disabled={disabledBtn}
        >
          {viewSaveButton ? "SAVE" : "UPDATE"}
        </button>
      )}

      {/* Save */}
      {onSave && (<button
        type="button"
        className={disabledBtn ? mainTable.disabledSubmitButton : mainTable.submitButton}
        onClick={onSave}
        disabled={disabledBtn}
      >
        Save
      </button>
      )}

      {/* Save and Proceed */}
      {onSaveAndProceed && (<button
        type="button"
        className={disabledBtn ? mainTable.disabledSubmitButton : mainTable.submitButton}
        onClick={onSaveAndProceed}
        disabled={disabledBtn}
      >
        Save and Proceed
      </button>)}

      {cancel && (<button
        data-modal-hide="bottom-right-modal"
        type="button"
        className={mainTable.cancelButton}
        onClick={cancel}
      >
        Cancel
      </button>)}

      {onCheckAvailability && (
        <button
          type="button"
          className={mainTable.addButton}
          onClick={onCheckAvailability}
          disabled={disabledBtn}
        >
          Check Availability
        </button>
      )}
      {onLost && addScreenTitle && (
        <button
              type="button"
              className={mainTable.addButton}
              onClick={onLost}
             >Lost
        </button>)}


      {onBooking && addScreenTitle && (
        <button
              type="button"
              onClick={onBooking}
              className={mainTable.addButton}
              >Confirm Booking
        </button>)}

      {onHold && addScreenTitle && (
        <button
              type="button"
              className={mainTable.addButton}
              onClick={onHold}
              >On Hold
        </button>)}



    </div>
  );
};

export default Buttons;
